import { log2 } from "../../utils/log2";
import { addWebhook, deleteWebhook, getAllWebHooks, updateWebHook } from "../../api/webhook";

const log = log2("webhook");

const webhook = {
    namespaced: true,
    state: {
        allWebHooks: [],
    },
    getters: {},
    mutations: {
        SET_ALL_WEB_HOOKS(state, payload) {
            log("SET_ALL_WEB_HOOKS", payload);
            state.allWebHooks = payload;
        },
        UPDATE_WEBHOOK_LIST(state, webhook) {
            log("UPDATE_WEBHOOK_LIST", webhook);
            state.allWebHooks = [...state.allWebHooks, webhook];
        },
        DELETE_WEB_HOOK(state, webhook) {
            log("DELETE_WEB_HOOK", webhook);
            state.allWebHooks = state.allWebHooks.filter((item) => item._id !== webhook._id);
        },
    },
    actions: {
        async addNewWebHook({ commit }, payload) {
            try {
                const { data } = await addWebhook(payload);
                commit("UPDATE_WEBHOOK_LIST", data);
            } catch (e) {}
        },
        async updateWebHook({ commit }, payload) {
            try {
                const { data } = await updateWebHook(payload);
                commit("UPDATE_WEBHOOK_LIST", data);
            } catch (e) {}
        },
        async fetchUserWebHooks({ commit }) {
            try {
                const { data } = await getAllWebHooks();
                console.log("fetchUserWebHooks data", data);
                commit("SET_ALL_WEB_HOOKS", data);
                return data;
            } catch (e) {
                log.error(e);
            }
        },
        async deleteWebHook({ commit }, id) {
            await deleteWebhook(id);
            commit("DELETE_WEB_HOOK", id);
        },
    },
};

export default webhook;
